import {
	LaravelResponse,
	keyToUrl,
	withDestroyEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	BottomNavBarItemIndexResource,
	BottomNavBarItemOptionResource,
	BottomNavBarItemOrderRequest,
	BottomNavBarItemSaveResource,
	BottomNavBarItemUpdateResource,
} from "../types/bottomNavBarItem";

const baseKey = ["app", "bottom-nav-bar-items"];
export const bottomNavBarItemService = {
	baseKey,
	indexKey: baseKey,
	listKey: [...baseKey, "list"],
	index: () => axios.get<LaravelResponse<BottomNavBarItemIndexResource[]>>(keyToUrl(baseKey)),
	...withUpdateEndpoint<BottomNavBarItemSaveResource>(baseKey),
	...withShowEndpoint<BottomNavBarItemUpdateResource>(baseKey),
	...withStoreEndpoint<BottomNavBarItemSaveResource>(baseKey),
	...withDestroyEndpoint(baseKey),
	...withOptionsEndpoint<BottomNavBarItemOptionResource>(baseKey),
	reorder: (orderRequest: BottomNavBarItemOrderRequest) =>
		axios.put<undefined>(keyToUrl([...baseKey, "order"]), orderRequest),
};
